import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import ThemeContext from "./ThemeContext";
export default function ThemeProvider(param) {
    var value = param.value, children = param.children;
    return /*#__PURE__*/ _jsx(ThemeContext.Provider, {
        value: value,
        children: children
    });
}
